import * as React from 'react'
import { useState } from 'react'
import { useFormikContext } from 'formik'
import FormButtons, { FormButtonStateSetters, getOnSubmitWithCallback, SubmitAction, SubmitCallback } from './FormButtons'
import { useDispatch } from 'react-redux'
import { AxiosPromiseAction } from '../../reducers'
import { EntityFormWrapperProps } from './Form'

type Props<E = {}, V = {}> = EntityFormWrapperProps<E, V> & {
    addEntity: (values: V) => AxiosPromiseAction
    getResetValues?: (initialValues: V, values: V) => V
}

function Buttons<E, V>(props: FormButtonStateSetters<V> & Props<E, V>) {
    const { initialValues, resetForm, values } = useFormikContext<V>()

    return (
        <FormButtons<V>
            save={[(values: V) => props.addEntity(values)]}
            saveAndNew={[
                (values: V) => props.addEntity(values),
                () =>
                    resetForm(
                        props.getResetValues && {
                            values: props.getResetValues(initialValues, values),
                        },
                    ),
            ]}
            {...props}
        />
    )
}

export default function AddEntityForm<E, V>(props: Props<E, V>) {
    const [action, setAction] = useState<SubmitAction<V>>()
    const [callback, setCallback] = useState<SubmitCallback>()
    const dispatch = useDispatch()

    return (
        <props.form onSubmit={getOnSubmitWithCallback(dispatch, action, callback)} currentFile={props.currentFile}>
            <Buttons<E, V> {...props} setAction={setAction} setCallback={setCallback} />
        </props.form>
    )
}
